import './styles.scss';
import './QuizView.scss';
import classnames from 'classnames';
import { XIcon, TwitterShareButton, LineShareButton, LineIcon } from 'react-share';
import { OptionType, Quiz, ResultContent, ViewSetting } from "../../common/types";
import { ReactComponent as LeftImg } from '../../images/appreciation_background_left.svg';
import { ReactComponent as RightImg } from '../../images/appreciation_background_right.svg';


type QuizViewProps = {
  quizList: Quiz[];
  view: ViewSetting[];
  result: ResultContent;
  average: number;
  selectQuizName: string;
  url: string;
  onClick: (id: string, answer: number) => void;
}

const QuizView: React.FC<QuizViewProps> = ({
  quizList,
  view,
  result,
  average,
  selectQuizName,
  url,
  onClick,
}) => {
  console.log('view',view)
  return (
    <div className="quiz-view">
      <div className="quiz-view__wrapper">
        {
          quizList.map((quiz, i) => (
            <QuizCard
              quiz={quiz}
              num={i}
              view={view.find((v) => v.id === quiz.q_item_id)}
              onClick={onClick}
            />
          ))
        }
        {
          result.answerNum === result.questionNum ? (
            <ResultBlock result={result} average={average} selectQuizName={selectQuizName} url={url} />
          ) : null
        }
      </div>
    </div>
  );
}

type QuizCardProps = {
  quiz: Quiz;
  num: number;
  view: ViewSetting | undefined;
  onClick: (id: string, answer: number) => void;
}

const QuizCard: React.FC<QuizCardProps> = ({ quiz, num, view, onClick }) => {
  console.log(quiz)
  return (
    <div className="card">
      <p className="card__id">{`Q.${num + 1}`}</p>
      <p className="card__question">{quiz.question}</p>
      {
        quiz.question_image ? (
          <figure className="card__question-image">
            <img src={quiz.question_image} alt="" />
          </figure>
        ) : null
      }

      <div className={classnames({
        'card__options': !quiz.options_image_1,
        'card__options-image': !!quiz.options_image_1,
      })}>
        <OptionButton
          id={quiz.q_item_id}
          num={1}
          value={quiz.options_1}
          image={quiz.options_image_1}
          result={view?.result.options1}
          isDisabled={view?.isExplanation}
          onClick={onClick}
        />
        {quiz.options_2 || quiz.options_image_2 ?
          <OptionButton
            id={quiz.q_item_id}
            num={2}
            value={quiz.options_2}
            image={quiz.options_image_2}
            result={view?.result.options2}
            isDisabled={view?.isExplanation}
            onClick={onClick}
          />
        : null}
        {quiz.options_3 || quiz.options_image_3 ?
          <OptionButton
            id={quiz.q_item_id}
            num={3}
            value={quiz.options_3}
            image={quiz.options_image_3}
            result={view?.result.options3}
            isDisabled={view?.isExplanation}
            onClick={onClick}
          />
        : null}
        {quiz.options_4 || quiz.options_image_4 ?
          <OptionButton
            id={quiz.q_item_id}
            num={4}
            value={quiz.options_4}
            image={quiz.options_image_4}
            result={view?.result.options4}
            isDisabled={view?.isExplanation}
            onClick={onClick}
          />
        : null}
      </div>

      {
        view && view.isExplanation ? (
          <div className="explanation">
            <p className={classnames({
              'explanation__answer': true,
              'explanation__answer--success': view.isAnswer,
              'explanation__answer--failure': !view.isAnswer,
            })}>{view.isAnswer ? '正解！' : '間違っています！'}</p>
            <p className="explanation__a"><span>A.</span>{view.answer}</p>
            {
              quiz.explanation_image ? (
                <figure className="card__question-image">
                  <img src={quiz.explanation_image} alt="" />
                </figure>
              ) : null
            }
            <div className="explanation__detail">
              {quiz.explanation.split(/\n/).map((item) => (
                <p>{item}</p>
              ))}
            </div>
          </div>
        )
        : null
      }
    </div>

  )
}

type OptionButtonProps = {
  id: string;
  num: number;
  value: string;
  image: string | undefined;
  result: OptionType | undefined;
  isDisabled: boolean;
  onClick: (id: string, answer: number) => void;
}
const OptionButton: React.FC<OptionButtonProps> = ( { id, num, value, image, result, isDisabled, onClick }) => {

  console.log('id', id)

  return (
    <button
      className={classnames({
        'option-button': true,
        'option-button--success': result === 'GREEN',
        'option-button--failure': result === 'RED',
        'option-button--disable': result === 'GRAY',
      })}
      disabled={isDisabled}
      onClick={() => {onClick(id, num)}}
    >
      {image ? (
        <img src={image} alt="" className="option-button__image" />
      ): null}
      {value}
    </button>
  )
}

type ResultBlockProps = {
  result: ResultContent;
  average: number;
  selectQuizName: string;
  url: string;
}
const ResultBlock: React.FC<ResultBlockProps> = ({ result, average, selectQuizName, url }) => {

  return (
    <div className="result">
      <LeftImg className="result__deco" />
      <div className="result__wrapper">
        <div className="result__header">
          <p className="title">
            <span>{result.questionNum}</span>問中<span>{result.result}</span>問正解
          </p>
        </div>
        <div className="result__average">
          <p className="title">みんなの平均点<span>{average}</span>点</p>
        </div>
        {/* <div className="result__comment">
          <p className="comment">残念！ 日本神話について皆さんもぜひ学んでみてください！</p>
        </div> */}

        <div className="result__share">
          結果をシェア
          <div className="quiz-share">
            <TwitterShareButton url={url} title={`「${selectQuizName}」${result.questionNum}問中${result.result}問正解でした！`}>
              <XIcon size={40} />
            </TwitterShareButton>
            <LineShareButton className="line" url={url} title={`「${selectQuizName}」${result.questionNum}問中${result.result}問正解でした！`}>
              <LineIcon size={40} />
            </LineShareButton>
          </div>
        </div>
      </div>
      <RightImg className="result__deco result__deco--r" />
    </div>
  )
}

export default QuizView;